import {
  TrailingDanger,
  TrailingInactive,
  TrailingInfo,
  TrailingSuccess
} from '../../atoms/icons/text-input'

import {
  Hint,
  HintInfo,
  HintError,
  HintWarning,
  HintSuccess,
  HintReadOnly,
  HintInactive
} from './styled-components'

const textInputHintVariantOptions = {
  BASIC: 'basic',
  INFO: 'info',
  ERROR: 'error',
  WARNING: 'warning',
  SUCCESS: 'success',
  'READ-ONLY': 'read-only',
  INACTIVE: 'inactive'
}

const textInputHintVariantStyledOptions = {
  [textInputHintVariantOptions.BASIC]: Hint,
  [textInputHintVariantOptions.INFO]: HintInfo,
  [textInputHintVariantOptions.ERROR]: HintError,
  [textInputHintVariantOptions.WARNING]: HintWarning,
  [textInputHintVariantOptions.SUCCESS]: HintSuccess,
  [textInputHintVariantOptions['READ-ONLY']]: HintReadOnly,
  [textInputHintVariantOptions.INACTIVE]: HintInactive
}

const textInputHintIconsOptions = {
  [textInputHintVariantOptions.INFO]: <TrailingInfo size="icon-s" />,
  [textInputHintVariantOptions.ERROR]: <TrailingDanger size="icon-s" />,
  [textInputHintVariantOptions.SUCCESS]: <TrailingSuccess size="icon-s" />,
  [textInputHintVariantOptions.INACTIVE]: <TrailingInactive size="icon-s" />
}

export {
  textInputHintVariantOptions,
  textInputHintVariantStyledOptions,
  textInputHintIconsOptions
}
